<template>
  <div id="modal_popup_campaign" class="modal-popup">
    <div class="modal-popup-content">
      <a @click="showModalPopup('modal_popup_campaign', false)" class="close-button">
        <img src="@/assets/images/cms-mkt/close-button.svg" />
      </a>
      <!-- <div class="d-inline-block container-right"> -->
      <div class="offer-details-wrapper">
        <div class="addRewardLayout border-box flex-wrap flex-xl-nowrap justify-content-center">
          <div class="container-fluid d-flex flex-column align-items-center">
            <div v-for="(entry) in newCampaign.content " :key="entry.language" class="container-fluid d-flex flex-column align-items-center"  >
              <small class="text-break">{{ $t("cmsLang.language_" + entry.language.toUpperCase()) }}</small>
              <div class="row d-flex flex-column align-items-baseline w-80 ">
                <small class="text-break">{{ $t("cmsLang.campaignTitleLabel") }}</small>
                <input type="text" required v-model="entry.title" class="formedituser w-100" maxlength="50"/>
              </div>
              <div class="row d-flex flex-column align-items-baseline w-80">
                <small class="text-break">{{ $t("cmsLang.campaignDescriptionLabel") }}</small>
                <textarea required v-model="entry.body" class="formedituser w-100" maxlength="120" />
              </div>
               <div class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.campaignLinkLabel") }}</small>
              <input type="text" v-model="entry.link" class="formedituser w-100" />
            </div>
            </div>
            <!-- <div class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.rewardLabel") }}</small>
              <input type="number" v-model="newCampaign.upCoins" class="formedituser w-100" onwheel="return false;"/>
            </div> -->
            <div class="container-fluid d-flex flex-row align-items-baseline w-80">
              <div class=" d-flex flex-column justify-content-between w-80">
                <small class="text-break">{{ $t("cmsLang.startDateLabel") }}</small>
                <date-range class="invoices-filter" :noRanges="true" :single="true" :minDateOrder="minDate"
                  :time="newCampaign.start" @close="startDateSelected" />
              </div>
              <div class="d-flex flex-column justify-content-between w-80">
                <small class="text-break">{{ $t("cmsLang.hourLabel") }}</small>
                <multiselect v-model="newCampaign.hour" :options="hoursAvailable" :placeholder="$t('cmsLang.selectLabel')"
                  select-label="" selected-label="" deselect-label="" :multiple=false openDirection="bottom"
                  :limit=1></multiselect>
                </div>
            </div>
            <div class="container-fluid d-flex flex-column align-items-baseline w-80">
              <!-- <small class="text-break">{{ $t("cmsLang.hourLabel") }}</small>
              <multiselect v-model="newCampaign.hour" :options="hoursAvailable" :placeholder="$t('cmsLang.selectLabel')"
                select-label="" selected-label="" deselect-label="" :multiple=false openDirection="bottom"
                :limit=1></multiselect> -->

              <!-- <div class="radioButtonCustom">
                <label v-for="(hour, index) in hoursAvailable" :key="index">
                  <input name="categorytype" type="radio" :value="hour"
                    v-model="newCampaign.hour" :checked="hour === newCampaign.hour">
                  {{ hour }}</label>
              </div> -->
              <p v-html="$t('cmsLang.gameDateError')" class="red" v-if="this.dateError"></p>
              <p v-else></p>
            </div>
            <div class="container-fluid d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.campaignChannelLabel") }}</small>
              <!-- <input type="text" v-model="newCampaign.category" class="formedituser w-100" /> -->
              <div class="radioButtonCustom">
                <label v-for="(product, index) in channels" :key="index">
                  <input name="channeltype" type="radio" :value="product" disabled
                    @change="selectCampaignChannel($event.target, product)" :checked="product === newCampaign.channel">
                  {{ $t('cmsLang.channel_' + product) }}</label>
              </div>
            </div>
           
            <div class="container-fluid d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.categoryLabel") }}</small>
              <!-- <input type="text" v-model="newCampaign.category" class="formedituser w-100" /> -->
              <div class="radioButtonCustom">
                <label v-for="(product, index) in categoriesSelect" :key="index">
                  <input name="categorytype" type="radio" :value="product"
                    @change="selectCampaignCategory($event.target, product)" :checked="product === newCampaign.level">
                  {{ $t('cmsLang.campaignCategory_' + product) }}</label>
              </div>
            </div>
            <div v-if="this.error" class="row d-flex flex-column align-items-baseline w-80">
              <br />
              <p class="red">{{ $t('cmsLang.errorMessage_' + error.code) }}</p>
            </div>
            <div class="row d-flex flex-column align-items-baseline w-80">
              <br />
              <small class="text-break">{{ $t("cmsLang.publishLabel") }}</small>
              <div class="row d-flex flex-row align-items-baseline justify-content-between w-80">
                <a @click="submitNotification()" class="button-all button-blue">
                  {{ $t('cmsLang.saveLabel') }}

                </a>
                <a @click="showModalPopup('modal_popup_confirm', true)" class="button-all button-red">
                  {{ $t('cmsLang.deleteLabel') }}

                </a>
              </div>
            </div>
          </div>
        </div>


      </div>
      <!-- </div> -->
    </div>
    <div id="modal_popup_confirm" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_confirm', false)" class="close-button">
          <img src="@/assets/images/cms-mkt/close-button.svg" />
        </a>
        <br />
        <p>
          {{ $t("cmsLang.confirmDeleteGameMessage") }}
        </p>
        <div class="buttons">
          <a href="#" class="yesButton" @click="deleteGame()">
            {{ $t("cmsLang.notificationsChooseOptionYes") }}
          </a>
          <a href="#" class="noButton" @click="showModalPopup('modal_popup_confirm', false)">
            {{ $t("cmsLang.notificationsChooseOptionNo") }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import DateRange from "@/components/DateRange.vue";
  import httpServiceCustomer from "@/http/http-play.js";
  import Cookies from "js-cookie";

  export default {
    name: "NewCampaignPopup",

    props: {
      user: Object,
      notification: Object,
      image: String,
    },
    components: {
      DateRange,
      // VueEditor
    },
    data() {
      return {
        selectedCategory: false,
        newCampaign: {
          content: [{
            language: "ro",
            title: "",
            body: "",
            link: "",
            system: ""
          }, {
            language: "en",
            title: "",
            body: "",
            link: "",
            system: ""
          }],
          hour:"09",
          channel: "campaign",
          start: [],
          level: "",
          filter: "",
        },

        isAmount: false,
        previewImage: null,
        minDate: moment().toDate(),
        // products: [11, 12, 13, 14, 15],
        hoursAvailable: ["08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20"],
        languages: ["RO", "EN"],
        categoriesSelect: ["marketing", "operational"],
        channels: ["push"],
        dateError: false,
        imageError: null,
        error: null,
        isLoading: false,
        isSelectedAllAffiliates: false
      };
    },
    methods: {
      selectCampaignLanguage(element, language) {
        this.newCampaign.language = language;
      },
      selectCampaignCategory(element, category) {
        this.newCampaign.level = category;
      },
      selectCampaignChannel(element, channel) {
        this.newCampaign.channel = channel;
      },
      submitNotification() {
        // validare ??
        // construct notification object

        this.error = null;

        if (this.newCampaign.content[0].title === "") {
          this.error = { code: "MI3" };
          return;
        }
        if (this.newCampaign.content[0].body === "") {
          this.error = { code: "MI6" };
          return;
        }

        // this.showModalPopup("modal_popup_loading_cms", true);


        let submitNotification = {
          id: this.newCampaign.id,
          system: this.newCampaign.system,
          channel: this.newCampaign.channel,
          level: this.newCampaign.level,
          content: this.newCampaign.content
        }

        if (this.newCampaign.start.length > 0) {
          submitNotification.start = moment(this.newCampaign.start[0]).format('yyyy-MM-DD') + " " + this.newCampaign.hour + ":00";
        }

        if (this.newCampaign.id > 0) {
          this.updateNotification(submitNotification);
        } else {
          this.addNotification(submitNotification);
        }
      },
      updateNotification(notification) {
        httpServiceCustomer.customerService
          .updateCampaign(
            notification,
            Cookies.get("token")
          )
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              this.$emit("showinfo", "campaignModifiedSuccess", null);
              this.$emit("updatelist");

            } else {
              this.error = { code: response.status };
              this.$emit("showinfo", "", this.error);
            }
            this.showModalPopup("modal_popup_loading_cms", false);
            // this.showModalPopup("modal_popup_info", true);
          })
          .catch((error) => {
            if (error.response) {
              this.error = error.response.data;
            } else {
              this.error = ["undefined"];
            }
            // this.showModalPopup("modal_popup_loading_cms", false);
            this.showModalPopup("modal_popup_info", true);
            this.$emit("showinfo", "", this.error);
          });
      },
      addNotification(notification) {
        httpServiceCustomer.customerService
          .addNewCampaign(
            notification,
            Cookies.get("token")
          )
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              this.$emit("showinfo", "campaignAddSuccess", null);
              this.$emit("updatelist");

            } else {

              this.error = { code: response.status };
              this.$emit("showinfo", "", this.error);
            }
            this.showModalPopup("modal_popup_loading_cms", false);
            // this.showModalPopup("modal_popup_info", true);
          })
          .catch((error) => {
            if (error.response) {
              this.error = error.response.data;
            } else {
              this.error = ["undefined"];
            }
            this.showModalPopup("modal_popup_loading_cms", false);
            this.$emit("showinfo", "", this.error);
            // this.showModalPopup("modal_popup_info", true);
          });
      },
      deleteGame() {
        this.successMessage = "";
        this.error = null;
        this.showModalPopup("modal_popup_confirm", false);
        this.showModalPopup("modal_popup_loading_cms", true);

        httpServiceCustomer.customerService
          .deleteCampaign(
            this.newCampaign.id,
            Cookies.get("token")
          )
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              this.$emit("showinfo", "campaignDeleteSuccess", null);
              this.$emit("updatelist");
            } else {
              this.error = { code: response.status };
            }
            this.showModalPopup("modal_popup_loading_cms", false);
          })
          .catch((error) => {
            if (error.response) {
              this.error = error.response.data;
            } else {
              this.error = ["undefined"];
            }
            this.showModalPopup("modal_popup_loading_cms", false);
            this.$emit("showinfo", "", error);
          });
      },
      startDateSelected(value) {
        this.newCampaign.start = value;
      },
      timeSelected(value) {
        this.newCampaign.time = value;
      },
      created(){
        this.error = null;
      }
    },
    watch: {
      notification: function () {
        this.error = null;
        this.successMessage = "";
        this.newCampaign.id = this.notification.id;
        if (this.notification.id > 0) {
          this.newCampaign.start = this.notification.start ? [moment(new Date(this.notification.start), 'yyyy-MM-dd hh:mm')] : [moment()];
          this.newCampaign.hour = this.notification.start ? moment(new Date(this.notification.start), 'yyyy-MM-dd hh:mm').hours() : "09";
          this.newCampaign.level = this.notification.level;
          this.newCampaign.channel = this.notification.channel;
          this.newCampaign.filter = this.notification.filter;
          this.newCampaign.system = this.notification.system;
          this.newCampaign.content = this.notification.content;
        } else {
          this.newCampaign = {
            id: 0,
            level: "marketing",
            hour:"09",
            channel: "push",
            start: [moment()],
            filter: {},
            system: "",
            content: [{
              language: "ro",
              title: "",
              body: "",
              link: "",
            }, 
          {
              language: "en",
              title: "",
              body: "",
              link: "",
            }],
          }
        }
      },
    },
  };
</script>
<style scoped src="@/assets/styles/mkt-cms.css"></style>
<style scoped>

  .position {
    position: relative;
    left: 227px;
  }


  .contact-details-wrapper {
    justify-content: space-evenly;
    color: #2D3736;
  }

  .close-button {
    right: 30px;
    top: 15px;
  }

  .offer-details-wrapper {
    border-radius: 48px;
    background: #E5E5E5;
    overflow-y: auto;
    height: calc(100vh - 170px) !important;
  }

  small {
    font-family: "Krona One";
    font-weight: 400;
    font-size: 18px;
    text-transform: uppercase;
  }

  .w-80 {
    width: 80%;
  }

  .ql-toolbar.ql-snow {
    border: 2px solid #fff !important;
    border-radius: 48px !important;
  }

  .multiselect {
    border: 1px solid #d8d8d8;
    background: #f1f1f1 !important;
    height: 40px !important;
    /* border-radius: 20px; */

  }

  .multiselect__input {
    font-size: 15px !important;
    /* border-radius: 20px !important; */
  }

  .multiselect__tags {
    border-radius: 40px !important;
    padding: 8px -30px 0 8px !important;
  }
</style>
